"use strict";
"use client";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Turnstile = Turnstile;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js";
let scriptPromise = null;
function loadTurnstileScript() {
    if (typeof window === "undefined")
        return Promise.resolve();
    if (window.turnstile)
        return Promise.resolve();
    if (scriptPromise)
        return scriptPromise;
    scriptPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
        if (existing) {
            existing.addEventListener("load", () => resolve());
            existing.addEventListener("error", () => reject(new Error("Turnstile script failed to load")));
            return;
        }
        const script = document.createElement("script");
        script.src = SCRIPT_SRC;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error("Turnstile script failed to load"));
        document.head.appendChild(script);
    });
    return scriptPromise;
}
/**
 * Renders nothing until a siteKey is configured, so this can be dropped into
 * forms ahead of the Cloudflare account/site being created — mirrors
 * verifyCaptcha()'s server-side skip-when-unconfigured behavior.
 */
function Turnstile({ siteKey, onVerify, onExpire, onError, className, theme = "auto" }) {
    const containerRef = React.useRef(null);
    const widgetIdRef = React.useRef(null);
    const callbacksRef = React.useRef({ onVerify, onExpire, onError });
    callbacksRef.current = { onVerify, onExpire, onError };
    React.useEffect(() => {
        if (!siteKey || !containerRef.current)
            return;
        let cancelled = false;
        loadTurnstileScript()
            .then(() => {
            if (cancelled || !window.turnstile || !containerRef.current)
                return;
            widgetIdRef.current = window.turnstile.render(containerRef.current, {
                sitekey: siteKey,
                theme,
                callback: (token) => callbacksRef.current.onVerify(token),
                "expired-callback": () => callbacksRef.current.onExpire?.(),
                "error-callback": () => callbacksRef.current.onError?.(),
            });
        })
            .catch(() => callbacksRef.current.onError?.());
        return () => {
            cancelled = true;
            if (widgetIdRef.current && window.turnstile) {
                window.turnstile.remove(widgetIdRef.current);
                widgetIdRef.current = null;
            }
        };
    }, [siteKey, theme]);
    if (!siteKey)
        return null;
    return (0, jsx_runtime_1.jsx)("div", { ref: containerRef, className: className });
}
